<style>
/* Hide scrollbar for Chrome, Safari and Opera */
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.hide-scrollbar {
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}
</style>

<script setup>

import Sidebar from './Sidebar.vue'
import { computed, ref } from 'vue'
import { useAuthStore } from '@/stores/authStore'

const authStore = useAuthStore()

const organization = computed(() => authStore.activeOrganization)
const isMobileSidebarOpen = ref(false)
</script>

<template>
  <div v-if="organization && organization?.status !== 'active'"
    class="flex items-center py-4 px-6 text-red-800 border-t-4 border-red-300 bg-red-50" role="alert">
    <svg class="shrink-0 w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor"
      viewBox="0 0 20 20">
      <path
        d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
    </svg>
    <div class="ms-3 text-sm font-medium">
      To continue with the <strong>HasMCP Cloud</strong>,
      please choose a
      <router-link :to="{ name: 'Billing', params: { id: organization?.id } }"
        class="underline text-green-700 hover:text-green-800">
        <strong>subscription plan</strong></router-link>. If you are not sure on which plan to
      start, you can start with <strong>Hobby plan</strong> which has <strong>250 tool calls per month for
        free</strong>.
    </div>
  </div>
  <div class="flex flex-col md:flex-row bg-zinc-100 font-inter"
    :class="organization && organization?.status !== 'active' ? 'h-[calc(100dvh-58px)]' : 'h-[100dvh]'">
    
    <!-- Mobile Header -->
    <div class="md:hidden flex items-center justify-between p-4 bg-white border-b border-gray-200 shrink-0 shadow-sm z-30">
      <div class="flex items-center gap-2 font-bold text-gray-900">
        <div class="w-8 h-8 rounded-lg border border-gray-200 bg-white flex items-center justify-center shrink-0">
          <svg width="20" height="20" viewBox="0 0 256 256">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g>
                <rect stroke="#000000" stroke-width="16" x="38" y="38" width="180" height="180" rx="18"></rect>
                <rect fill="#000000" x="91" y="96" width="24" height="64" rx="12"></rect>
                <rect fill="#000000" x="139" y="96" width="24" height="64" rx="12"></rect>
                <rect fill="#000000" x="95" y="116" width="64" height="24" rx="12"></rect>
                <rect fill="#000000" x="79" y="0" width="24" height="64" rx="12"></rect>
                <rect fill="#000000" x="152" y="0" width="24" height="64" rx="12"></rect>
                <rect fill="#000000" x="80" y="192" width="24" height="64" rx="12"></rect>
                <rect fill="#000000" x="152" y="192" width="24" height="64" rx="12"></rect>
                <rect fill="#000000" x="0" y="80" width="64" height="24" rx="12"></rect>
                <rect fill="#000000" x="0" y="152" width="64" height="24" rx="12"></rect>
                <rect fill="#000000" x="192" y="80" width="64" height="24" rx="12"></rect>
                <rect fill="#000000" x="192" y="152" width="64" height="24" rx="12"></rect>
              </g>
            </g>
          </svg>
        </div>
        HasMCP
      </div>
      <button @click="isMobileSidebarOpen = true" class="p-2 -mr-2 text-gray-600 hover:bg-gray-100 rounded-lg outline-none">
        <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>
    </div>

    <Sidebar :is-mobile-open="isMobileSidebarOpen" @close-mobile="isMobileSidebarOpen = false" />

    <main class="grow p-4 md:py-4 md:pr-4 md:pl-0 h-full min-h-0 flex flex-col">
      <div class="h-full overflow-y-auto rounded-2xl scroll-smooth bg-white border border-gray-200">
        <div class="px-4 py-6 md:px-16 md:pt-8 md:pb-8 max-w-7xl md:min-w-3xl">
          <router-view />
        </div>
      </div>
    </main>
  </div>
</template>